<template>
  <div>
    <div id="checkoutPopup" class="modal fade" role="dialog">
      <div class="modal-dialog profile-confirm-poup">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header confirmpopup-bgcolor p-0">
            <div class="add-record-title">
              <div>{{ $t("confirmCheckout") }}</div>
              <div @click="closeModal()" class="close-icon cursor-pointer">
                <img src="/static/images/icons/ul_close_icon.svg" class="address-images" />
              </div>
            </div>
          </div>
          <div class="modal-body confirm-body">
            <div class="subscribe-body">
              <span v-if="$i18n.locale === 'Portuguese'">Você está prestes a prosseguir com a compra no total de</span>
              <span v-else>You are about to proceed with purchase for total</span> <span class="text-bold">{{ (new Intl.NumberFormat(this.$i18n.locale === 'Portuguese' ? 'pt-BR' : 'en-US', { style: 'currency', currency: 'BRL' }).format(totalPrice)) }} </span>
              <span v-if="$i18n.locale === 'Portuguese' && paymentId === 1">com o "<span class="text-bold">Cartão XXXX XXXX XXXX {{ creditCardDetails.card_number.substr(-4) }}</span>".</span>
              <span v-else-if="$i18n.locale === 'Portuguese' && paymentId !== 1">com a forma de pagamento "<span class="text-bold">{{paymentType}}</span>".</span>
              <span v-else>with the <span v-if="paymentId !== 1">"<span class="text-bold">{{paymentType}}</span>" payment method.</span><span v-else>"<span class="text-bold">Card XXXX XXXX XXXX {{ creditCardDetails.card_number.substr(-4) }}</span>".</span></span>
            </div>
            <div class="proceed-title">
              {{ $t("popupConfirm") }}
            </div>
          </div>
          <div class="modal-footer confirmpopup-bgcolor col-xs-12 col-sm-12 d-flex-sm-end">
            <div class="">
              <button type="button" class="btn btn-block cancel-changes" @click="closeModal()">{{ $t('cancel') }}</button>
            </div>
            <div class="">
              <button type="button" class="btn btn-block proceed-changes" @click="subscribe()">{{ $t('yesProceed') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <loader :loadingStatus="loaderStatus"></loader>
  </div>
</template>
<script>
import $ from 'jquery';
import Loader from '../UIComponents/Loader.vue';

export default {
  components: {
    Loader,
  },
  props: [
    'totalPrice',
    'paymentId',
    'paymentType',
    'creditCardDetails',
  ],
  data() {
    return {
      loaderStatus: false,
    };
  },
  methods: {
    closeModal() {
      $('#checkoutPopup').modal('hide');
      this.$emit('closePopup');
    },
    subscribe() {
      $('#checkoutPopup').modal('hide');
      this.$emit('submit');
      // next popup
    },
  },
};
</script>
  <style scoped>
  label {
      display: inline-block;
      max-width: 100%;
      margin-bottom: 0px !important;
      /* font-weight: 700; */
  }
  .modal-header {
      background-color: #ffffff !important;
      border-bottom: 1px solid #d3d3d3 !important;
      border-top-right-radius: 6px!important;
      border-top-left-radius: 6px!important;
  }
  .modal-header .close {
      background: unset;
      opacity: 1;
      line-height: unset;
      width: unset;
      border-radius: unset;
      color: unset;
      background-color: #ffffff !important;
  }
  .add-record-title {
      display: flex;
      justify-content: space-between;
      font-weight: 600;
      font-size: 20px;
      line-height: 27px;
      color: #1a1a1a;
      padding: 12px 0px 11px 16px;
  }
  .close-icon {
      padding-right: 16px;
  }
  .proceed-title {
      font-weight: 600;
      font-size: 16px;
      line-height: 22px;
      color: #333333;
      padding: 16px 0 23px 0;
  }
  .modal-body {
      padding: 25px 55px 0px 24px;
  }
  .market-title {
      font-weight: 400;
      font-size: 16px;
      line-height: 26px;
      color: #3e3e3e;
  }
  label>input[type="radio"] {
      display: none;
  }
  label>input[type="radio"]+*::before {
      content: "";
      display: inline-block;
      vertical-align: bottom;
      width: 18px;
      height: 18px;
      margin-right: 11px;
      margin-bottom: 4px;
      border-radius: 50%;
      border-style: solid;
      border-width: 1px;
      border-color: #00518a;
      border: 2px solid #4d4d4d;
  }
  label>input[type="radio"]:checked+*::before {
      background: radial-gradient(#00518a 0%, #00518a 46%, transparent 51%, transparent);
      border-color: #00518a;
      border: 2px solid #00518a;
  }
  .proceed-changes,
  .proceed-changes:hover {
      background-color: #01518a;
      height: 44px;
      width: auto;
      color: #ffffff;
      font-size: 18px;
      font-weight: 600;
      border-radius: 3px;
      line-height: 22px;
      float: right;
      cursor: pointer;
      padding: 9px 16px;
      text-transform: capitalize;
  }
  .cancel-changes,
  .cancel-changes:hover {
      background-color: #ffffff;
      height: 44px;
      width: auto;
      color: #000;
      font-size: 18px;
      font-weight: 600;
      border-radius: 3px;
      line-height: 22px;
      float: right;
      cursor: pointer;
      padding: 9px 16px;
      border: 1px solid #000001;
  }
  .modal-footer {
      background-color: #fafaf9 !important;
      padding-right: 0px;
      border: none !important;
      border-bottom-right-radius: 6px;
      border-bottom-left-radius: 6px;
  }
  .modal-content {
   border: none;
   border-top-right-radius: 6px!important;
   border-top-left-radius: 6px!important;
   border-bottom-right-radius: 0!important;
   border-bottom-left-radius: 0!important;
  }
  .pb-21 {
   padding-bottom: 21px;
  }
  .radio-buttons {
   padding-left: 19px;
   padding-bottom: 27px;
  }
  @media (min-width: 768px) {
  .modal-dialog {
   width: 500px;
   margin: 30px auto;
  }
  }
  .subscribe-body {
    font-size: 18px;
    color: #333333;
    font-weight: 400;
    font-style: normal;
    line-height: 25px;
  }
  </style>
